import styled from 'styled-components'

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 360px;
  max-width: calc(100vw - 32px);
  min-height: 320px;
  padding: 36px;
  background: #fff;
  box-shadow: 0 0 100px rgba(0, 0, 0, 0.08);

  form {
    width: 100%;
  }

  button {
    width: 100%;
  }
`

export const Logo = styled.div`
  text-align: center;
  cursor: pointer;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 64px;
    margin-right: 8px;
  }

  span {
    vertical-align: text-bottom;
    font-size: 16px;
    text-transform: uppercase;
    display: inline-block;
    font-weight: 700;
    color: @primary-color;
  }
`

export const RecaptchaStatus = styled.p`
  min-height: 20px;
  margin: 0 0 16px;
  font-size: 12px;
  line-height: 1.5;
  color: ${(props) => (props.error ? '#cf1322' : 'rgba(0, 0, 0, 0.45)')};
  text-align: center;
`

export const RecaptchaHint = styled.p`
  margin: 16px 0 0;
  font-size: 12px;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;

  a {
    color: inherit;
    text-decoration: underline;
  }
`
